import Joi from '@hapi/joi'

export const SubBlockWeightmentDetailsReportSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    estateID: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Select Operation Entity`,
        "any.required": `Operation Entity required`
    }),

    divisionID: Joi.number().invalid(0).required().label("Collection Point").messages({
        "any.invalid": `Select Collection Point`,
        "any.required": `Collection Point required`
    }),
    fieldID: Joi.number().allow(0, "", null).optional().label("fieldID"),
    registrationNumber: Joi.string().max(50).allow("", null).label("registrationNumber"),

    subFieldID: Joi.number().allow("", null).label("subFieldID"),

    searchDate: Joi.string().invalid("").label("Date"),
};
